import { Directive, Injectable, Input, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ScrollSpy]'
})
export class ScrollSpyDirective {

  @Input() public spiedTags:any[] = [];
  @Output() public sectionChange = new EventEmitter<string>();
  private currentSection: string | undefined;

  constructor(private _el: ElementRef) { }
  
  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    //console.log("Scroll Started");
    
    let currentSection: string | undefined;
    const children = this._el.nativeElement.children;
    const scrollTop = event.target.scrollTop;
    const parentOffset = event.target.offsetTop;
    
    for (let i = 0; i < children[0].childNodes[0].childNodes.length; i++) {
      const element = children[0].childNodes[0].childNodes[i];
      if (this.spiedTags.some(spiedTag => spiedTag === element.nodeName)) {
        if ((element.offsetTop - parentOffset) <= scrollTop) {
          currentSection = element.id;
        }
      }
    }
    
    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }

}
